import React, {useEffect, useState, useRef, useContext} from "react";
import "./SurveyViewer.css";
import { config } from "../../config";

 export const FinishedSurveyScreen = (props) => { 
        return(
      
        <div className="finished_survey_screen_full_page">
            <div className="finished_survey_screen_shadow">
            <div className="finished_survey_screen_container">
                <h1>Upitnik je uspješno ispunjen.</h1>
                <h1>Zahvaljujemo vam na suradnji!</h1>
                <h1 className="finished_survey_screen_link">Projektne rezultate pratite na javnoj <a href={`${config.appUrl}/nationaldatabase`}>Platformi</a></h1>
            </div>
            </div>
        </div>
 

    );
}
 export default FinishedSurveyScreen;